import styled from "styled-components";

export const CheckboxWrapper = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CheckboxBoxWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 12px;
  width: 24px;
  height: 24px;
`;

export const CheckboxBox = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 4px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: grid;
  place-items: center;

  &.has-error {
    border-color: ${({ theme }) => theme.colors.error};
  }
`;

export const CheckboxLabel = styled.div`
  font-size: 18px;
  line-height: 24px;
  margin-top: 2px;
  vertical-align: top;
  font-weight: 500;
  display: inline-block;

  &.has-error {
    color: ${({ theme }) => theme.colors.error};
  }
`;

export const CheckboxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
`;
